// Shared max-widths for standalone (non-MainLayout) pages.
//
// MainLayout already centralizes the authenticated-app widths via its
// `OutletContainer` (64rem default / 90rem wide / 100% full-bleed). These
// tokens cover the pages that render OUTSIDE that shell — auth, public,
// legal, wizard flows — which used to hardcode scattered px values
// (480/520/560/800/820). One bucket per visual family so a scanner page
// and a 1-action card no longer drift apart by 40px.

/** Public document read-only page: lot passport, DDT, inspection portal. */
export const PUBLIC_DOCUMENT_MAX_WIDTH = 820;

/** Full-screen centered card for multi-step / state flows (onboarding,
 *  trial-expired, accept-invite, archive download). */
export const CARD_FLOW_MAX_WIDTH = 560;

/** Compact centered card for a single public action (unsubscribe, magic link). */
export const CARD_CENTERED_MAX_WIDTH = 480;
